import * as React from 'react';
import styled from 'styled-components';
import { IconStyle } from '../Icon.styles.js';
const _IconPaymentInvoice = (props) => {
    const { 'data-test-id': dataTestId, className, size, style, ...rest } = props;
    return (React.createElement("span", { "data-test-id": dataTestId, className: className, style: style }, size === '24'
        ? React.cloneElement(React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M12.352 8.866c.182 0 .324-.04.427-.12.107-.079.175-.212.203-.398h1.309c-.047.597-.25 1.04-.61 1.33-.354.284-.79.427-1.308.427-.5 0-.933-.133-1.302-.4-.364-.27-.618-.671-.763-1.203h-.553v-.826h.434v-.357h-.434v-.82h.553c.14-.536.392-.937.756-1.203.368-.271.805-.406 1.309-.406.518 0 .954.144 1.309.434.36.284.562.725.609 1.323h-1.31c-.032-.187-.102-.32-.21-.4-.102-.079-.242-.118-.42-.118-.298 0-.513.123-.643.37h.819v.82h-.994v.175c0 .084.002.144.007.182h.987v.826h-.812c.13.242.343.364.637.364ZM16 11.5H8V13h8v-1.5Zm-8 3h8V16H8v-1.5Zm8 3H8V19h8v-1.5ZM5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v18Zm1.5-.5h11v-17h-11v17Z", fill: "currentColor", fillRule: "evenodd" })), { width: 24, height: 24, ...rest })
        : null));
};
const defaultProps = {
    size: '24',
};
export const IconPaymentInvoice = styled(_IconPaymentInvoice) `
    ${IconStyle}
`;
IconPaymentInvoice.defaultProps = defaultProps;
//# sourceMappingURL=IconPaymentInvoice.js.map